// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__oT-63","title":"ClientReferral_title__skIBo","itemText":"ClientReferral_itemText__1SheN"};